var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"access-denied"},[_c('h1',[_vm._v("Acceso Denegado")]),_c('p',[_vm._v("No tienes permiso para acceder a esta página.")]),_c('button',{on:{"click":_vm.goBack}},[_vm._v("Volver")])])}
var staticRenderFns = []

export { render, staticRenderFns }